import { Link } from 'react-router-dom';
import { CalendarClock, FileText, ListChecks, Package as PackageIcon, Send } from 'lucide-react';
import { usePageTitle } from '../../hooks/usePageTitle';

export function DocumentsHomePage() {
  usePageTitle('Documents');
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-800">Documents</h1>
        <p className="text-slate-500 text-sm mt-1">
          Upload templates, group them into bundles, and send them to customers for signing.
        </p>
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        <HomeCard
          to="/documents/send"
          icon={<Send size={20} className="text-sky-600" />}
          title="Send"
          description="Fill merge fields and email documents and signing links"
        />
        <HomeCard
          to="/documents/sent"
          icon={<ListChecks size={20} className="text-sky-600" />}
          title="Sent documents"
          description="Track signing status and audit detail."
        />
        <HomeCard
          to="/documents/validity"
          icon={<CalendarClock size={20} className="text-sky-600" />}
          title="Document validity"
          description="See what's valid, expiring, or lapsing before the next visit."
        />
        <HomeCard
          to="/documents/templates"
          icon={<FileText size={20} className="text-sky-600" />}
          title="Templates"
          description="Manage active templates. Upload .docx & PDF files with merge fields."
        />
        <HomeCard
          to="/documents/packages"
          icon={<PackageIcon size={20} className="text-sky-600" />}
          title="Bundles"
          description="Bundle templates into named groups."
        />
      </div>
    </div>
  );
}

function HomeCard({
  to,
  icon,
  title,
  description
}: {
  to: string;
  icon: React.ReactNode;
  title: string;
  description: string;
}) {
  return (
    <Link
      to={to}
      className="bg-white border border-slate-200 rounded-xl p-5 hover:border-sky-400 hover:shadow-sm transition block"
    >
      <div className="flex items-center gap-2 mb-2">{icon}<h3 className="font-semibold text-slate-800">{title}</h3></div>
      <p className="text-sm text-slate-500">{description}</p>
    </Link>
  );
}
